import React from 'react';

import { ModalOverlay } from './styles';

interface IModalProps {
  show: boolean;
  children: React.ReactNode;
  modalClosed: ((e: React.SyntheticEvent) => void) | undefined;
}

/* eslint-disable import/no-default-export */
export default ({ show, children, modalClosed }: IModalProps) => (
  <ModalOverlay
    style={{
      transform: show ? 'translateY(0)' : 'translateY(-100vh)',
      opacity: show ? 1 : 0,
    }}
    data-testid="skeleton"
    onClick={modalClosed}
  >
    {show ? children : null}
  </ModalOverlay>
);
